import * as angular from 'angular';
import * as query from 'query-string';
import * as _ from 'lodash';
import * as swal from 'sweetalert';
import {AccountService} from "../../../account/core/services/AccountService";
export class SearchPageComponent implements ng.IComponentOptions {
  public controller: any = SearchPageController;
  public template: string = /*html*/`
  <div class="container container-fluid padding-2">

  <div class="row">
    <div class="col-sm-3" style="padding-right: 0">
      <div class="card">
        <div class="part f-column">
          <!-- Group -->
          <div class="part-100 side-header b-bottom" ng-click="isGrpCollapsed=!isGrpCollapsed">Group</div>
          <div class="part-100 side-content" uib-collapse="isGrpCollapsed" ng-init="grpLimit=10">
            <ul>
              <li ng-repeat="group in $ctrl.groups|limitTo:grpLimit" ng-click="$ctrl.updateGroup(group.name)" ng-class="{'selected': ($ctrl.q.group.indexOf(group.name)>-1)}">{{group.name}}</li>
            </ul>
            <div class="more" ng-show="$ctrl.groups.length > 10 && grpLimit === 10"><a ng-click="grpLimit = $ctrl.groups.length">Show More</a></div>
            <div class="more" ng-show="$ctrl.groups.length > 10 && grpLimit === $ctrl.groups.length"><a ng-click="grpLimit = 10">Show Less</a></div>
          </div>
          <!-- Group -->
          <div class="part-100 side-header b-bottom" ng-click="isCatCollapsed=!isCatCollapsed">Category</div>
          <div class="part-100 side-content" uib-collapse="isCatCollapsed" ng-init="catLimit=10">
            <ul>
              <li ng-repeat="category in $ctrl.categories|limitTo:catLimit" ng-click="$ctrl.updateCategory(category.name)" ng-class="{'selected': ($ctrl.q.category.indexOf(category.name)>-1)}">{{category.name}}</li>
            </ul>
            <div class="more" ng-show="$ctrl.categories.length > 10 && catLimit === 10"><a ng-click="catLimit = $ctrl.categories.length">Show More</a></div>
            <div class="more" ng-show="$ctrl.categories.length > 10 && catLimit === $ctrl.categories.length"><a ng-click="catLimit = 10">Show Less</a></div>
          </div>
          <div class="part-100 side-header b-bottom" ng-click="isMinCollapsed=!isMinCollapsed">Ministry</div>
          <div class="part-100 side-content" uib-collapse="isMinCollapsed" ng-init="ministryLimit=10">
            <ul>
              <li ng-repeat="ministry in $ctrl.ministries|limitTo:ministryLimit" ng-click="$ctrl.updateMinistry(ministry.name)" ng-class="{'selected': ($ctrl.q.ministry.indexOf(ministry.name)>-1)}">{{ministry.display_name}}</li>
            </ul>
            <div class="more" ng-show="$ctrl.ministries.length > 10 && ministryLimit === 10"><a ng-click="ministryLimit = $ctrl.ministries.length">Show More</a></div>
            <div class="more" ng-show="$ctrl.ministries.length > 10 && ministryLimit === $ctrl.ministries.length"><a ng-click="ministryLimit = 10">Show Less</a></div>
          </div>
          <div class="part-100 side-header b-bottom" ng-click="isAgenCollapsed=!isAgenCollapsed">Agency</div>
          <div class="part-100 side-content" uib-collapse="isAgenCollapsed" ng-init="agencyLimit=10">
            <ul>
              <li ng-repeat="agency in $ctrl.agencies|limitTo:agencyLimit" ng-click="$ctrl.updateAgency(agency.name)" ng-class="{'selected': ($ctrl.q.agency.indexOf(agency.name)>-1)}">{{agency.display_name}}</li>
            </ul>
            <div class="more" ng-show="$ctrl.agencies.length > 10 && agencyLimit === 10"><a ng-click="agencyLimit = $ctrl.agencies.length">Show More</a></div>
            <div class="more" ng-show="$ctrl.agencies.length > 10 && agencyLimit === $ctrl.agencies.length"><a ng-click="agencyLimit = 10">Show Less</a></div>
          </div>
          <div class="part-100 side-header b-bottom" ng-click="isTypeCollapsed=!isTypeCollapsed" ng-if="$ctrl.isAdmin || $ctrl.isInternal">Type</div>
          <div class="part-100 side-content" uib-collapse="isTypeCollapsed" ng-if="$ctrl.isAdmin || $ctrl.isInternal">
            <ul>
              <li ng-click="$ctrl.updateType('raw')" ng-class="{'selected': ($ctrl.q.type === 'raw')}">Raw (Original)</li>
              <li ng-click="$ctrl.updateType('cleansed')" ng-class="{'selected': ($ctrl.q.type === 'cleansed')}">Raw (Cleansed)</li>
              <li ng-click="$ctrl.updateType('aggregate')" ng-class="{'selected': ($ctrl.q.type === 'aggregate')}">Aggregate</li>
            </ul>
          </div>
          <div ng-show="$ctrl.isAdmin" class="part-100 side-header b-bottom" ng-click="isStatusCollapsed=!isStatusCollapsed">Status</div>
          <div ng-show="$ctrl.isAdmin"  class="part-100 side-content" uib-collapse="isStatusCollapsed">
            <ul>
              <li ng-click="$ctrl.updateStatus('pending', true)" ng-class="{'selected': ($ctrl.q.pending === true)}">Pending Review</li>
              <li ng-click="$ctrl.updateStatus('processed', true)" ng-class="{'selected': ($ctrl.q.processed === true)}">Processed</li>
              <li ng-click="$ctrl.updateStatus('processed', false)" ng-class="{'selected': ($ctrl.q.processed === false)}">Unprocessed</li>
              <li ng-click="$ctrl.updateStatus('deleted', true)" ng-class="{'selected': ($ctrl.q.deleted === true)}">Deleted</li>
            </ul>
          </div>
          <div ng-show="$ctrl.isAdmin" class="part-100 side-header b-bottom"  ng-click="isSharedCollapsed=!isSharedCollapsed">Share Access</div>
          <div ng-show="$ctrl.isAdmin" class="part-100 side-content" uib-collapse="isSharedCollapsed">
            <ul>
              <li ng-click="$ctrl.q.private=!$ctrl.q.private;$ctrl.q.internal=null;$ctrl.updatePage()" ng-class="{'selected': ($ctrl.q.private === true)}">Private</li>
              <li ng-click="($ctrl.q.private === false && $ctrl.q.internal === false)? $ctrl.cancel(['private','internal']): $ctrl.setPublic()" ng-class="{'selected': ($ctrl.q.internal === false)}">Public</li>
              <li ng-click="(!$ctrl.isExist('internal') || $ctrl.q.internal === true)? $ctrl.cancel('internal'): $ctrl.setAllAgency()" ng-class="{'selected': ($ctrl.q.internal === true)}">All Agency</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-9">
    <p ng-show="!$ctrl.datasets.length">No Record Found</p>
    <breadcrumb tree="$ctrl.tree"></breadcrumb>
    <div class="card row margin-bottom">
    <div class="col-sm-12">
    <div class="padding">
    <form ng-submit="$ctrl.updatePage()">
    <div class="input-icon">
    <i class="fa fa-fw fa-search"></i>
    <input type="text" class="form-control" placeholder="Search" ng-model="$ctrl.q.q"/>
    </div>
    </form>
    </div>
    </div>
    <div class="col-sm-12">
      <div class="part b-top">
      <div class="part-100">
        {{$ctrl.total}} Results
        <span ng-show="$ctrl.q.ministry||$ctrl.q.agency||$ctrl.q.category||$ctrl.q.group||$ctrl.q.tag||$ctrl.q.datatype">filtered by</span>
        <a class="tagline" ng-show="$ctrl.q.ministry" ng-repeat="ministry in $ctrl.q.ministry">Ministry: {{ministry}} <span ng-click="$ctrl.cancel('ministry', $index)">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.q.agency" ng-repeat="agency in $ctrl.q.agency">Agency: {{agency}} <span ng-click="$ctrl.cancel('agency', $index)">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.q.category" ng-repeat="category in $ctrl.q.category">Category: {{category}} <span ng-click="$ctrl.cancel('category', $index)">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.q.group" ng-repeat="group in $ctrl.q.group">Group: {{group}} <span ng-click="$ctrl.cancel('group', $index)">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.q.tag">Tag: {{$ctrl.q.tag}} <span ng-click="$ctrl.cancel('tag')">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.q.datatype">Dataset: {{$ctrl.q.datatype}} <span ng-click="$ctrl.cancel('datatype')">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.q.type">Type: {{$ctrl.q.type}} <span ng-click="$ctrl.cancel('type')">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.isExist('quality')">Quality: {{$ctrl.q.quality}} <span ng-click="$ctrl.cancel('quality')">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.isExist('processed')">Processed: {{$ctrl.q.processed}} <span ng-click="$ctrl.cancel('processed')">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.isExist('published')">Published: {{$ctrl.q.published}} <span ng-click="$ctrl.cancel('published')">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.isExist('deleted') && $ctrl.q.deleted === true">Deleted <span ng-click="$ctrl.cancel('deleted')">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.isExist('private') && $ctrl.q.private === true">Private <span ng-click="$ctrl.cancel(['internal', 'private'])">&times;</span></a>
        <a class="tagline" ng-show="(!$ctrl.isExist('private') && $ctrl.isExist('internal') && $ctrl.q.internal === false) || ($ctrl.q.private === false && $ctrl.isExist('internal') && $ctrl.q.internal === false) || ($ctrl.isExist('private') && $ctrl.q.private === false && !$ctrl.isExist('internal'))">Public <span ng-click="$ctrl.cancel(['internal', 'private'])">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.isExist('internal') && $ctrl.q.internal === true">All Agency <span ng-click="$ctrl.cancel(['internal', 'private'])">&times;</span></a>
        <a class="tagline" ng-show="$ctrl.isExist('pending') && $ctrl.q.pending === true">Pending Review <span ng-click="$ctrl.cancel('pending')">&times;</span></a>
        <div class="pull-right">
          Sort By <select name="sort" ng-model="$ctrl.q.sort" ng-change="$ctrl.updatePage()"><option value="L">Latest</option><option value="P">Most Popular</option><option value="V">Top View</option><option value="D">Top Download</option></select>
        </div>
      </div>
      </div>
    </div>
    </div>
    <div class="card row margin-bottom" ng-repeat="dataset in $ctrl.datasets">
    <div class="col-sm-12">
      <div class="part b-bottom">
      <div class="part-100">
        <a class="data-title" ng-href="#/dataset/{{dataset._id}}" ng-class="{'text-danger':dataset.deletedOn}"><span class="data-deleted" ng-show="dataset.deletedOn"><i class="fa fa-fw fa-exclamation-triangle" style="color:#FFF"></i> Deleted</span>{{dataset.display_name}}</a>
        <a ng-show="dataset.datatype.category" ng-click="$ctrl.updateCategory(dataset.datatype.category)" class="data-category">{{dataset.datatype.category}}</a>
        <span class="badge bg-light" ng-show="dataset.private">Private</span>
        <span class="badge bg-red" ng-show="dataset.status==='dirty'&&dataset.is_processed===false&&dataset.status!=='cleansed'">Unprocessed</span>
        <span class="badge bg-red" ng-show="dataset.quality==='poor'&&dataset.is_processed===true&&dataset.status!=='cleansed'">Process Failed</span>
        <span class="badge bg-light" ng-show="dataset.status==='cleansed'&&dataset.internal===false&&!dataset.private">Published(Public)</span>
        <span class="badge bg-light" ng-show="dataset.status==='cleansed'&&dataset.internal===true&&!dataset.private">Published(Agencies)</span>
        <span class="badge-sm" ng-class="$ctrl.getClass(resource.extension)" style="margin-right:5px" ng-repeat="resource in dataset.resources|unique:'extension'">{{resource.extension.substr(1)}}</span>
        <span class="pull-right" ng-show="dataset.type==='raw'">
          <i class="fa fa-fw fa-list"></i>Raw (Original)
        </span>
        <span class="pull-right" ng-show="dataset.type==='cleansed'">
          <i class="fa fa-fw fa-list"></i>Raw (Cleansed)
        </span>
        <span class="pull-right" ng-show="dataset.type==='aggregate'">
          <i class="fa fa-fw fa-table"></i>Aggregated
        </span>
      </div>
      </div>
      <div class="part padding-0">
      <div class="part-70 b-right padding-0">
        <div class="part b-bottom padding"><p class="clamp-to-3" ng-bind-html="$ctrl.sanitize(dataset.description)"></p></div>
        <div class="part f-column padding">
          <div class="padding-0" ng-show="dataset.agency||dataset.ministry">by {{dataset.agency.display_name||dataset.ministry.display_name}}</div>
          <div class="padding-0"><strong>Tags</strong>&nbsp;<a ng-click="$ctrl.updateTag(tag)" ng-repeat="tag in dataset.tags" style="margin-right:5px;">{{tag}}</a></div>
        </div>
      </div>
      <div class="part-30">
      <div class="data-subcontent">
        <div class="data-subtitle">Uploaded By</div>
        {{dataset.user.usertype === 'admin'?'Administrator':dataset.user.fullname}}
        <div class="data-subtitle">Updated On</div>
        {{dataset.updatedOn|date:'MMM, dd yyyy'}}
        <div class="data-subtitle">Views</div>
        {{dataset.views}}
      </div>
      </div>
      </div>
    </div>
    </div>
    <ul uib-pagination total-items="$ctrl.total" ng-model="$ctrl.q.page" ng-change="$ctrl.updatePage()"  ng-show="$ctrl.datasets.length" class="pagination-sm" boundary-link-numbers="true"></ul>
    </div>
  </div>
  `
}

export class SearchPageController {
  public static $inject: Array<string> = ["AccountService", "$http", "$location", "$uibModal", "$stateParams", "$anchorScroll", '$sce'];
  public tree: Array<any>;
  public search: {text: string};
  public q: any;
  public datasets: Array<any>;
  public total: number;
  public isAdmin: boolean;
  public isInternal: boolean;
  public categories: Array<any>;
  public ministries: Array<any>;
  public agencies: Array<any>;
  public datatypes: Array<any>;
  public groups: Array<any>;
  public extras: {category?: any, ministry?: any, agency?: any};
  constructor(private account: AccountService, private $http: ng.IHttpService, private $location: ng.ILocationService, private $uibModal: ng.ui.bootstrap.IModalService, private $stateParams: ng.ui.IStateParamsService, private $anchorScroll: ng.IAnchorScrollService, private $sce: ng.ISCEService) {
    this.tree = [
      {name: "Datasets Exploration", path: "#/search"}
    ];
    this.search = {text: ""};
    try {
      this.q = JSON.parse(decodeURIComponent($location.search().q));
    }
    catch(err) {
      this.q = {};
    }
    if ($location.search().agency) {
      this.q.agency = [$location.search().agency];
    }
    if ($location.search().group) {
      this.q.group = [$location.search().group];
    }
    if ($location.search().ministry) {
      this.q.ministry = [$location.search().ministry];
    }
    if ($location.search().category) {
      this.q.category = [$location.search().category];
    }
    if (!_.isNull($stateParams.processed))
      this.q.processed = $stateParams.processed;
    if (!_.isNull($stateParams.published))
      this.q.published = $stateParams.published;
    if (!_.isNull($stateParams.quality))
      this.q.quality = $stateParams.quality;
    if (!_.isNull($stateParams.type))
      this.q.type = $stateParams.type;
    if (!_.isNull($stateParams.private))
      this.q.private = $stateParams.private;
    if (!_.isNull($stateParams.internal))
      this.q.internal = $stateParams.internal;
    if (!_.isNull($stateParams.pending))
      this.q.pending = $stateParams.pending;
    if (!this.q.page)
      this.q.page = 1;
    this.q.sort = 'L';
    this.extras = {};
    account.$promise.then(() => {
      this.isAdmin = (account.usertype === 'admin');
      this.isInternal = (account.usertype === 'internal');
    })
    this.getData();
    $http.get(`${BASE}/classification?type=category`).then((d:any) => {
      this.categories = d.data;
    });
    $http.get(`${BASE}/classification?type=group`).then((d:any) => {
      this.groups = d.data;
    });
    $http.get(`${BASE}/ministry`).then((d:any) => {
      this.ministries = d.data;
    });
    $http.get(`${BASE}/agency`).then((d:any) => {
      this.agencies = d.data;
    });
    $http.get(`${BASE}/datatype`).then((d:any) => {
      this.datatypes = d.data;
    })
  }
  public $onInit() {
    this.$anchorScroll();
    localStorage.setItem("lastPage", this.$location.url())
  }
  public getData() {
    let url = `api/search?q=${encodeURIComponent(JSON.stringify(this.q))}`;
    this.$http.get(url)
    .then((d:any) => {
      this.datasets = d.data.result;
      this.total = d.data.count;
    })
  }
  public cancel(type, idx?:any) {
    if (type === 'group' || type === 'agency' || type === 'ministry' || type === 'category') {
      this.q[type].splice(idx, 1);
      this.extras = _.omit(this.extras, [type]);
    }
    else {
      this.q = _.omit(this.q, [type]);
    }
    this.updatePage()
  }
  public updatePage() {
    this.$location.search({q: encodeURIComponent(JSON.stringify(this.q))});
    localStorage.setItem("lastPage", this.$location.url())
    this.getData();
    this.$anchorScroll();
  }
  public setPublic() {
    this.q.private = false;
    this.q.internal = false
    this.updatePage()
  }
  public setAllAgency() {
    this.q.internal = true
    this.updatePage()
  }
  public updateCategory(category) {
    if (!this.q.category)
      this.q.category = [];
    if (this.q.category.indexOf(category) > -1) {
      this.cancel('category', this.q.category.indexOf(category));
      return;
    }
    this.q.category.push(category);
    this.q.page = 1;
    this.updatePage();
  }
  public updateGroup(group) {
    if (!this.q.group)
      this.q.group = [];
    if (this.q.group.indexOf(group) > -1) {
      this.cancel('group', this.q.group.indexOf(group));
      return;
    }
    this.q.group.push(group);
    this.q.page = 1;
    this.updatePage();
  }
  public updateTag(tag) {
    this.q.tag = tag;
    this.q.page = 1;
    this.updatePage();
  }
  public updateMinistry(ministry) {
    if (!this.q.ministry)
      this.q.ministry = [];
    if (this.q.ministry.indexOf(ministry) > -1) {
      this.cancel('ministry', this.q.ministry.indexOf(ministry));
      return;
    }
    this.q.ministry.push(ministry);
    this.q.page = 1;
    this.updatePage();
  }
  public updateAgency(agency) {
    if (!this.q.agency)
      this.q.agency = [];
    if (this.q.agency.indexOf(agency) > -1) {
      this.cancel('agency', this.q.agency.indexOf(agency));
      return;
    }
    this.q.agency.push(agency);
    this.q.page = 1;
    this.updatePage();
  }
  public updateType(type) {
    if (this.q.type === type) {
      this.cancel('type');
      return;
    }
    this.q.type = type;
    this.q.page = 1;
    this.updatePage();
  }
  public updateDatatype(type) {
    if (this.q.datatype === type) {
      this.cancel('datatype');
      return;
    }
    this.q.datatype = type;
    this.q.page = 1;
    this.updatePage();
  }
  public updateStatus(type, value) {
    if (this.q[type] === value)
      this.q = _.omit(this.q, [type]);
    else
      this.q[type] = value;
    if (type === 'pending' && value === true) {
      this.q.private = true
    }
    this.q.page = 1;
    this.updatePage();
  }
  public updateOwner(type) {
    if (this.q.owner === type) {
      this.cancel('owner');
      return;
    }
    this.q.owner = type;
    this.q.page = 1;
    this.updatePage();
  }
  public updateInternal(type) {
    if (angular.isDefined(this.q.internal) && this.q.internal === type) {
      this.cancel('internal');
      return;
    }
    this.q.internal = type;
    this.q.page = 1;
    this.updatePage();
  }
  public deleteDataset(dataset) {
    swal({
      title: "Warning!",
      text: `Are you sure want to delete ${dataset.display_name}`,
      type: "warning",
      showCancelButton: true,
    },isConfirm => {
      if (isConfirm) {
        this.$http.delete(`${BASE}/api/dataset/${dataset._id}`).then(() => {
          this.updatePage();
        })
        .catch(() => swal("Sorry!", "Failed to delete dataset, please try again later", "error"))
      }
    })
  }
  public restore(dataset) {
    swal({
      title: "Warning!",
      text: `Are you sure want to restore ${dataset.display_name}`,
      type: "warning",
      showCancelButton: true,
    },isConfirm => {
      if (isConfirm) {
        this.$http.post(`${BASE}/api/dataset/restore/${dataset._id}`,{}).then(() => {
          this.updatePage();
        })
        .catch(() => swal("Sorry!", "Failed to restore dataset, please try again later", "error"))
      }
    })
  }
  public editDataset(dataset) {
    let _modalInstance = this.$uibModal.open({
      component: 'datasetModal',
      resolve: {
        dataset: () => {
          return dataset;
        }
      }
    });
    _modalInstance.result.then(() => {
      this.getData();
    })
  }
  public getClass(ext) {
    switch(ext) {
      case ".csv":
        return "bg-yellow";
      case ".xls":
      case ".xlsx":
        return "bg-green";
      case ".jpg":
      case ".jpeg":
      case ".png":
      case ".gif":
        return "bg-purple";
      case ".pdf":
        return "bg-red";
      case ".json":
      case ".xml":
        return "bg-orange";
    }
    return "";
  }
  public showMore(type) {
    let _list: Array<any>;
    switch(type) {
      case "category":
        _list = _.slice(this.categories, 10);
        break;
      case "ministry":
        _list = _.slice(this.ministries, 10);
        break;
      case "agency":
        _list = _.slice(this.agencies, 10);
        break;
    }
    let _modal = this.$uibModal.open({
      component: 'showMoreModal',
      resolve: {
        list: () => {
          return _list;
        }
      }
    })
    _modal.result.then((d) => {
      this.q[type] = d.name;
      this.extras[type] = d;
      this.updatePage();
    })
  }
  public isExist(type) {
    return _.has(this.q, type);
  }
  public sanitize(text) {
    return this.$sce.getTrustedHtml(text)
  }
}
